import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import { setAgencyData } from "../../../helpers/agencyTracker";
import {
  getPhoneByHeader,
  portalSubscribe,
  toApiMsisdn,
} from "./services";
import UnitelPortalSignupPageDisplay from "./SignupPage.styled";
import "../UnitelSignupPage/UnitelSignupPage.scss";

function UnitelPortalSignupPage({ t }) {
  const [phone, setPhone] = useState("");
  const [isHeFlow, setIsHeFlow] = useState(false);
  const [headerReady, setHeaderReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initializing, setInitializing] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [showError, setShowError] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [termsAndConditions, setTermsAndConditions] = useState(true);
  const termsRef = useRef(null);

  useEffect(() => {
    const urlsearch = window.location.search;
    if (urlsearch) {
      setAgencyData(urlsearch);
    }
    loadHeaderEnrichment();
  }, []);

  const loadHeaderEnrichment = async () => {
    setInitializing(true);
    setHeaderReady(false);

    try {
      const data = await getPhoneByHeader("./checkheaderunitel.php");
      const msisdn = data && (data.msisdn || data.Msisdn || data.phone);

      if (msisdn) {
        setPhone(String(msisdn).replace(/[^0-9]/g, ""));
        setIsHeFlow(true);
      } else {
        setPhone("");
        setIsHeFlow(false);
      }
    } catch (error) {
      console.error(error);
      setPhone("");
      setIsHeFlow(false);
    } finally {
      setHeaderReady(true);
      setInitializing(false);
    }
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setShowError(false);
    setErrorMsg("");
    setSuccessMsg("");

    if (!termsAndConditions) {
      setErrorMsg(t("accept_subscribe") || "Please accept terms and conditions");
      setShowError(true);
      return;
    }

    const msisdn = toApiMsisdn(phone);
    if (!msisdn) {
      setErrorMsg(t("Empty Phone Number Or Password") || "Phone number is required");
      setShowError(true);
      return;
    }

    setLoading(true);
    try {
      const data = await portalSubscribe(msisdn);

      if (data && data.status === true) {
        setSuccessMsg(
          data.message ||
            "Pedido de subscricao enviado com sucesso"
        );
        return;
      }

      setErrorMsg(
        (data && data.message) || t("register.SUBSCRIBE_ERROR") || "Subscribe failed"
      );
      setShowError(true);
    } catch (error) {
      const apiMessage =
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message;
      setErrorMsg(
        apiMessage ||
          (error && error.message) ||
          t("register.SUBSCRIBE_ERROR") ||
          "Subscribe failed"
      );
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  const canSubmit =
    headerReady &&
    !initializing &&
    !loading &&
    termsAndConditions &&
    Boolean(toApiMsisdn(phone));

  return (
    <UnitelPortalSignupPageDisplay className="">
      {showError ? (
        <FloatingAlert type="error">
          <Trans>{errorMsg}</Trans>
        </FloatingAlert>
      ) : null}

      {(loading || initializing) && (
        <div className="load">
          <div className="spinerC">
            <div className="spinner" />
          </div>
        </div>
      )}

      <div className="operatorSignup gamezoneSignup">
        <div className="formsLayout">
          <div className="header header_gamezone">
            <Link to="/">
              <div className="logo gamezoneLogo" />
            </Link>
          </div>

          <div className="links-Section links-SectionGamezone">
            <h3 className="gamezoridcontent" id="gamezoridcon">
              <Trans>Your content is ready!</Trans>
            </h3>
            <div className="play" />

            {successMsg ? (
              <div className="success-box">
                <p>{successMsg}</p>
              </div>
            ) : (
              <form className="unitel-form-wrap" onSubmit={handleSubscribe}>
                {isHeFlow ? (
                  <p className="he-msisdn">{phone}</p>
                ) : (
                  headerReady && (
                    <div className="unitel-phone-row">
                      <input
                        type="text"
                        className="input gamezoneInput unitel-keyph"
                        value="+244"
                        disabled
                        readOnly
                        aria-label="Country code"
                      />
                      <input
                        type="tel"
                        className="input gamezoneInput unitel-numph"
                        placeholder={t("Enter_your_phone_number")}
                        value={phone}
                        autoComplete="tel"
                        disabled={loading || initializing}
                        onChange={(e) =>
                          setPhone(e.target.value.replace(/[^0-9]/g, ""))
                        }
                      />
                    </div>
                  )
                )}

                <button
                  className="btn btngamezone"
                  type="submit"
                  disabled={!canSubmit}
                >
                  {loading || initializing
                    ? t("loading") || "Loading..."
                    : t("Subscribe")}
                </button>
              </form>
            )}

            <span className="price-note">
              220 Kzs/Semana
              <br />
              Será subscrito ao portal PlayIT por 220 Kzs renováveis
            </span>

            <div className="footer">
              <div className="ncellTos">
                <h3>
                  <input
                    type="checkbox"
                    defaultChecked
                    ref={termsRef}
                    className="inputcheck"
                    id="agree"
                    onChange={() =>
                      setTermsAndConditions(
                        termsRef.current ? termsRef.current.checked : true
                      )
                    }
                  />
                  <a
                    href="http://ao.playit.mobi/tos"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "white",
                      cursor: "pointer",
                      fontSize: "24px",
                    }}
                  >
                    <Trans>terms_and_conditions</Trans>
                  </a>
                </h3>
              </div>
            </div>

            <div className="row text-center">
              <div className="col-xl-4 col-lg-4 col-4 px-5">
                <div className="games-info">
                  <span>98%</span>
                  <img
                    src="/assets/images/subscribegamezriod/like.png"
                    alt="img"
                    className="iconsimg"
                  />
                  <p>
                    <Trans>evaluation</Trans>
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-4 px-5">
                <div className="games-info">
                  <span>1000+</span>
                  <img
                    src="/assets/images/subscribegamezriod/Repeat.png"
                    alt="img"
                    className="iconsimg"
                  />
                  <p>
                    <Trans>game</Trans>
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-4 px-5">
                <div className="games-info">
                  <span>500k+</span>
                  <img
                    src="/assets/images/subscribegamezriod/group.png"
                    alt="img"
                    className="iconsimg"
                  />
                  <p>
                    <Trans>user</Trans>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UnitelPortalSignupPageDisplay>
  );
}

export default withTranslation()(UnitelPortalSignupPage);
